import { FaUsers } from "react-icons/fa6";

export const linksRH = [
	{ label: "Usuarios", path: "/usuariosRS", icon: FaUsers },
];
